//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      linkList: (state) => state.linkList,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/download/index.vue